
import lazyInject from '@/di';
import OrderService from '@/services/order.service';
import { AuthEnum } from '@/services/permission.service';
import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';

@Component({})
export default class PartialRefoundPopover extends Vue {
  clicked = false;

  visible = false;
  @Ref('formRef')
  formRef!: FormModel;

  AuthEnum = AuthEnum;
  formData = {
    amount: '',
    reason: '',
    part: undefined,
  };

  refundAmount = 0;

  refundNum = 0;

  labelCol = { span: 4 };
  wrapperCol = { span: 14 };
  rules = {
    part: [{ required: true, message: '请选择退款类型' }],
    amount: [
      { required: true, message: '请输入退款金额' },
      {
        validator: this.validatorAmount,
      },
    ],
    reason: [{ required: true, message: '请输入退款原因' }],
  };

  @Prop({
    default: 0,
  })
  orderId!: number;

  @Prop({
    default: {},
  })
  payPrice!: any;

  @Prop()
  isPay!: string;

  refundablePrice: any = 0;

  dragReset: any = null;

  @lazyInject(OrderService)
  orderService!: OrderService;

  @Watch('visible', { immediate: true })
  visibleDragReset() {
    if (this.visible) return;
    if (this.dragReset) {
      this.dragReset();
    }
  }

  handleClickChange(visible: boolean) {
    this.clicked = visible;
  }

  handleDragReset(resetFn: any) {
    this.dragReset = resetFn;
  }

  /** 退款确认 */
  async refund(id: number, data: any) {
    const res = await this.orderService.refund(id, data);
    if (!res) {
      return;
    }
    this.$message.success(res);
    this.formRef.resetFields();
    this.clicked = false;
    this.visible = false;
    this.refundNum = 0;
    this.refundAmount = 0;
    this.$emit('refresh', true);
  }

  validatorAmount(rule: any, value: any, callback: any) {
    if (value < 0.01) {
      callback(new Error('退款金额不能小于0'));
    } else if (value > this.refundablePrice) {
      console.log(this.refundablePrice);
      callback(new Error('退款金额不能大于订单可退金额'));
    } else {
      callback();
    }
  }

  modelClick() {
    this.refundablePrice = this.payPrice;
    console.log(this.isPay);
    if (this.isPay === '部分退款') {
      this.getAudioManager();
    } else {
      this.visible = true;
    }
  }

  changePart() {
    if (this.formData.part === 2) {
      this.formData.amount = this.refundablePrice;
    } else {
      this.formData.amount = '';
    }
  }

  async getAudioManager() {
    const data = {
      order_id: this.orderId,
    };
    const res: any = await this.orderService.getBackgroundAudioManager(data);
    console.log(res);
    const refundAmount = (res.amount as number) - (res.refund_amount as number);
    console.log(refundAmount);
    this.refundablePrice = refundAmount;
    this.refundAmount = res.refund_amount;
    this.refundNum = res.refund_num;
    console.log(this.refundablePrice);
    this.visible = true;
  }

  handleOk() {
    this.formRef.validate((valid) => {
      if (valid) {
        this.$confirm({
          title: '操作确认',
          content: `退款金额为${this.formData.amount}元,确认操作退款吗?`,
          onOk: async () => {
            await this.refund(this.orderId, this.formData);
          },
          onCancel() {},
          class: 'test',
        });
      }
    });
  }

  handleClick() {
    this.formRef.resetFields();
    this.refundNum = 0;
    this.refundAmount = 0;
    this.visible = false;
  }
}
